import { QueryClient } from "@tanstack/react-query";
import { ApiError } from "./api";

/**
 * Retries are for a network that blinked, never for an answer the server
 * meant. Retrying a 401 or a 403 turns one refused request into three, and
 * against the login route that spends somebody else's rate-limit budget.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: (failureCount, error) => {
          if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false;
          return failureCount < 2;
        },
        staleTime: 5_000,
      },
      mutations: { retry: false },
    },
  });
}
